import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { Community } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

export function useCommunities() {
  const { data, error, isLoading, mutate } = useSWR<{ communities: Community[] }>(
    '/api/communities',
    fetcher
  );

  return {
    communities: data?.communities || [],
    isLoading,
    isError: error,
    mutate,
  };
}
